const accessMaster = {

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Update Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Update State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Update City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    CATEGORY_LIST: { name: 'Category', path: '/category-list' },
    ADD_CATEGORY: { name: 'Add Category', path: '/create-category' },
    UPDATE_CATEGORY: { name: 'Update Category', path: '/edit-category' },
    DELETE_CATEGORY: { name: 'Delete Category', path: '/delete-category' },

    UNIT_LIST: { name: 'Unit', path: '/unit-list' },
    ADD_UNIT: { name: 'Add Unit', path: '/create-unit' },
    UPDATE_UNIT: { name: 'Update Unit', path: '/edit-unit' },
    DELETE_UNIT: { name: 'Delete Unit', path: '/delete-unit' },

    PINCODE_LIST: { name: 'Pincode', path: '/pincode-list' },
    ADD_PINCODE: { name: 'Add Pincode', path: '/create-pincode' },
    UPDATE_PINCODE: { name: 'Update Pincode', path: '/edit-pincode' },
    DELETE_PINCODE: { name: 'Delete Pincode', path: '/delete-pincode' },

}

export default accessMaster;